export class OrderItemOptionEntity {
    ItemOptionId!: string;
    OrderItemId!: string;
    Quantity = 0;
    Price!: number;
  }
  